<template>
  <nuttrema-layout-content>
    <template slot="header">
      <instance-standard-header
        :meta="meta"
        :InstanceDetails="InstanceDetails">
        <div slot="edit" class="content-header-item">
          <permissions-control-wrapper
             action="label.edit"
            :required-general="$PERMISSIONS_GENERAL.EDIT_PROFILE"
            :permissions="_get(InstanceDetails, 'meta.permissions')">
            <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
            <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
          </permissions-control-wrapper>
        </div>
      </instance-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="InstanceDetails.fetching"></nuttrema-loader>
      <form-instance-logo
         v-else
        :edit="edit"
        :InstanceDetails="InstanceDetails"
        @uploadInstanceLogo="uploadInstanceLogo"
        @removeInstanceLogo="removeInstanceLogo"
        @uploadInstanceLogoSuccess="handleUploadInstanceLogoSuccess">
      </form-instance-logo>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import NuttremaOverlayHelpButton from 'components/ui/overlay/nuttrema-overlay-help-button';

import PageProps from 'components/mixins/page-props';
import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import InstanceStandardHeader from 'components/pages/professional/instance/shared/cmpt-instance-standard-header';

import FormInstanceLogo from './form-instance-logo';

export default {
  name: 'page-instance-logo',
  mixins: [PageProps],
  components: {
    FormInstanceLogo,
    NuttremaLayoutContent,
    InstanceStandardHeader,
    NuttremaOverlayHelpButton,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    InstanceDetails() {
      return this.$store.getters.InstanceDetails;
    },
  },
  methods: {
    ...mapActions([
      'SaveInstanceLogo',
      'RemoveInstanceLogo',
    ]),
    uploadInstanceLogo(file) {
      return this.SaveInstanceLogo({ file })
        .then(() => {
          this.successNotification({ label: 'label.instance_logo' });
        }).catch(() => {
          this.errorNotification({ label: 'label.instance_logo' });
        });
    },
    removeInstanceLogo() {
      return this.RemoveInstanceLogo()
        .then(() => {
          this.successNotification({
            message: 'message.default_success_delete_message',
            label: 'label.instance_logo',
          });
        }).catch(() => {
          this.errorNotification({ message: 'default_error_message' });
        });
    },
    handleUploadInstanceLogoSuccess() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/instance-logo/page-instance-logo.vue